import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgLimit = (props) => /* @__PURE__ */ _jsx("svg", {
	width: "1.125em",
	height: "1.125em",
	viewBox: "0 0 24 24",
	fill: "currentColor",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M16 5V19H20V5H16ZM4 19H8V13H4V19ZM10 19H14V9H10V19ZM22 19C22 19.5304 21.7891 20.039 21.4141 20.4141C21.039 20.7891 20.5304 21 20 21H4C3.46957 21 2.96101 20.7891 2.58594 20.4141C2.21086 20.039 2 19.5304 2 19V13C2 12.4696 2.21086 11.961 2.58594 11.5859C2.96101 11.2109 3.46957 11 4 11H8V9C8 8.46957 8.21087 7.96101 8.58594 7.58594C8.96101 7.21087 9.46957 7 10 7H14V5C14 4.46957 14.2109 3.96101 14.5859 3.58594C14.961 3.21087 15.4696 3 16 3H20C20.5304 3 21.039 3.21086 21.4141 3.58594C21.7891 3.96101 22 4.46957 22 5V19Z",
		fill: "currentColor"
	})
});
export default SvgLimit;
